module.exports = __webpack_public_path__ + "img/settings.e5c8305c.png";